var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "list-container" },
    [
      _vm.isMask ? _c("div", { staticClass: "mask" }) : _vm._e(),
      _c("Header", {
        on: { anchorScoll: _vm.scollTop, showMask: _vm.toggleMask }
      }),
      _c(
        "div",
        { staticClass: "list" },
        [
          _c("div", { staticClass: "teads_here1" }),
          _c("h3", { staticClass: "listTitle" }, [_vm._v(_vm._s(_vm.query))]),
          _c(
            "div",
            { staticClass: "content" },
            _vm._l(_vm.list, function(item) {
              return _c(
                "a",
                {
                  key: item.ID,
                  staticClass: "newsBox",
                  attrs: { href: "/detail/" + item.ID }
                },
                [
                  _c("div", { staticClass: "newsImg" }, [
                    _c("img", {
                      attrs: { src: item.meta_attached_file, alt: "" }
                    })
                  ]),
                  _c(
                    "div",
                    { staticClass: "labelBox" },
                    _vm._l(item.post_tag, function(val, index) {
                      return _c(
                        "a",
                        {
                          key: index,
                          staticClass: "newsLabel",
                          attrs: {
                            href: "/list/tag/" + (val || "").toLocaleLowerCase()
                          }
                        },
                        [_vm._v("#" + _vm._s(val))]
                      )
                    }),
                    0
                  ),
                  _c("div", { staticClass: "newsIntroduct" }, [
                    _vm._v(_vm._s(item.post_title))
                  ]),
                  _c("div", { staticClass: "newsContent" }, [
                    _vm._v(_vm._s(item.post_excerpt))
                  ]),
                  _c("div", { staticClass: "newsDate" }, [
                    _vm._v(_vm._s(item.post_date))
                  ])
                ]
              )
            }),
            0
          ),
          _c("Pagination", {
            attrs: {
              total: _vm.total,
              pageSize: _vm.pageSize,
              "item-render": _vm.itemRender
            },
            on: { change: _vm.onPageSizeChange },
            model: {
              value: _vm.page,
              callback: function($$v) {
                _vm.page = $$v
              },
              expression: "page"
            }
          }),
          _c("div", { staticClass: "teads_here2" })
        ],
        1
      ),
      _c("Footer", {
        attrs: { isMobile: _vm.isMobile },
        on: { pageTop: _vm.pageTop }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js?{"compilerOptions":{"preserveWhitespace":false},"extractCSS":true}!./node_modules/vue-loader/lib?{"compilerOptions":{"preserveWhitespace":false},"extractCSS":true}!./src/views/List.vue?vue&type=template&id=20863650&scoped=true&
// module id = 434
// module chunks = 0